var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bank-foot"},[_c('van-button',{staticClass:"web-btn",staticStyle:{"width":"calc(100vw - 32px)","margin":"10px 16px"},on:{"click":_vm.toAdd}},[_vm._v(_vm._s(_vm.$t('common.binding')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }